/* npm modules outside of vrbo */
import React, {Fragment, useContext} from 'react';
import PropTypes from 'prop-types';

/* Atoms (baseline) */
import {ButtonPrimary} from '../../atoms/baseline/baseline';

/* Atoms (custom) */
import {Typography} from '../../atoms/Typography/Typography';

/* Molecules (custom) */
import {BOOKING_CONFIRMATION} from '../../../utils/edapUtils';
import {Guest} from '../Guest/Guest';
import {GuestViewAccess} from '../GuestViewAccess/GuestViewAccess';

/* Styles */
import './HasGuests.less';
import VrbexContext from '../../context/VrbexContext';

export const HasGuests = ({
    actionLocation,
    addGuestsModalButtonLabel,
    addGuestUrl,
    addGuestsWidgetHeading,
    guests,
    guestsLabel,
    handleInviteButtonClick,
    guestAccessLabel,
    removeGuest,
    removingGuestEmail,
    sendInvite,
    tooltipContent,
    translations,
}) => {
    const {isVrbex} = useContext(VrbexContext);
    let button = (
        <ButtonPrimary
            className={'HasGuests__addGuestBtn text-center'}
            label={addGuestsModalButtonLabel}
            onClick={handleInviteButtonClick}
        />
    );
    if (isVrbex && actionLocation === BOOKING_CONFIRMATION) {
        button = (
            <ButtonPrimary
                className={'HasGuests__addGuestBtn text-center'}
                label={addGuestsModalButtonLabel}
                href={addGuestUrl}
            />
        );
    }
    return (
        <Fragment>
            <Typography
                className="HasGuests__title"
                content={addGuestsWidgetHeading}
                TagName="h2"
            />
            <GuestViewAccess
                guestAccessLabel={guestAccessLabel}
                placement={'left'}
                tooltipContent={tooltipContent}
                tooltipType={'popover'}
                trigger={'hover focus'}
            />
            <Typography
                className="HasGuests__guest-count"
                content={`${guestsLabel} (${guests.length})`}
                TagName="strong"
            />
            {guests.map((guest, index) => (
                <Guest
                    key={`guest-${index}`}
                    isLoading={guest.email === removingGuestEmail}
                    removeGuest={removeGuest}
                    resendEmail={sendInvite}
                    translations={translations}
                    {...guest}
                />
            ))}
            {button}
        </Fragment>
    );
};

HasGuests.propTypes = {
    actionLocation: PropTypes.string.isRequired,
    addGuestsModalButtonLabel: PropTypes.string.isRequired,
    addGuestUrl: PropTypes.string,
    addGuestsWidgetHeading: PropTypes.string.isRequired,
    guestAccessLabel: PropTypes.string.isRequired,
    guests: PropTypes.arrayOf(PropTypes.object),
    guestsLabel: PropTypes.string.isRequired,
    removeGuest: PropTypes.func,
    removingGuestEmail: PropTypes.string,
    sendInvite: PropTypes.func,
    handleInviteButtonClick: PropTypes.func.isRequired,
    tooltipContent: PropTypes.element.isRequired,
};
